async function getCourt(court) {
  await this.$get('/report/courts?current=1&size=15&keyword=' + court).then((res) => {
    if (res.code === 0 && res.data && res.data.records && res.data.records.length) {
      return {
        id: res.data.records[0].id,
        name: res.data.records[0].name
      }
    } else {
      return null
    }
  }).catch((err) => {
    console.error(err)
  })
}
/**
 *
 * @param {object} value 企查查第三方数据
 * @param {string} key 属性名
 * @param {string} step 节点
 * @returns 查询后的值
 */
export default async function getQccKeyData(value, key, step) {
  if (value && value.length) {
    const judgmentDoc = value[0].judgmentDoc
    const courtAnno = value[0].courtAnno
    const filingCase = value[0].filingCase
    switch (key) {
      // 起诉-递交材料-受理日期
      case 'court':
        if (judgmentDoc) {
          return await getCourt(judgmentDoc.Court)
        }

        if (courtAnno) {
          return await getCourt(courtAnno.Court)
        }

        if (filingCase) {
          return await getCourt(filingCase.Court)
        }
        break
        // 起诉-受理-受理日期
      case 'acceptDate':
        if (filingCase) {
          return filingCase.LianDate
        }
        break
        // 起诉-受理-案号
      case 'caseNumber':
        if (filingCase && filingCase.CaseType === '民事' && step !== '执行') {
          return filingCase.CaseNo
        }

        if (filingCase && filingCase.CaseType === '执行' && step === '执行') {
          return filingCase.CaseNo
        }
        break
        // 庭前-审判长
      case 'presidingJudge':
        if (courtAnno) {
          return courtAnno.JusticeChief
        }
        break
        // 庭审,庭前-开庭时间
      case 'courtTime':
        if (courtAnno) {
          return courtAnno.CourtTime
        }

        if (filingCase) {
          return filingCase.HoldDate
        }
        break
        // 判决-判决时间
      case 'judgmentDate':
        if (judgmentDoc) {
          return judgmentDoc.JudgeDate
        }
        break
        // 判决-判决时间
      case 'amount':
        if (judgmentDoc) {
          return judgmentDoc.Amount
        }
        break
        // 判决-判决摘录
      case 'remark':
        if (judgmentDoc) {
          return judgmentDoc.JudgeResult
        }
        break
    }
  }
}



// WEBPACK FOOTER //
// ./src/libs/qcc.js